import { AppProvider } from "./providers/app";
import { Routes } from "./routes";

function App() {
  return (
    <AppProvider>
      <Routes />
    </AppProvider>
  );
}

export default App;